module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-new-preorder"
  }, [_c('h2', [_vm._v("预定房间")]), (_vm.current_contract && _vm.current_contract.preorderable) ? _c('div', {
    staticClass: "ui icon positive message"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("可预定")]), _c('p', [_vm._v("当前合同已标记为"), _c('b', [_vm._v("可预定")]), _vm._v("，并将于 " + _vm._s(_vm.days_to_end) + " 天后 (" + _vm._s(_vm.$formatters.date.to_date(_vm.current_contract.date_end)) + ") 到期。")])])]) : _vm._e(), (_vm.current_contract && !_vm.current_contract.preorderable && _vm.days_to_end > 0) ? _c('div', {
    staticClass: "ui icon warning message"
  }, [_c('i', {
    staticClass: "warning icon"
  }), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("当前合同未到期")]), _c('p', [_vm._v("距离当前合同到期还有 " + _vm._s(_vm.days_to_end) + " 天 (" + _vm._s(_vm.$formatters.date.to_date(_vm.current_contract.date_end)) + ")， 请核对信息确认无误后继续操作。")])])]) : _vm._e(), (!_vm.current_contract) ? _c('div', {
    staticClass: "ui icon positive message"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._m(0)]) : _vm._e(), _c('el-form', {
    ref: "form",
    staticClass: "ui form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "three fields"
  }, [_c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "date_start"
    }
  }, [_c('label', [_vm._v("开始日期")]), _c('datepicker', {
    attrs: {
      "type": "date",
      "editable": false,
      "clearable": false,
      "placeholder": "开始日期"
    },
    model: {
      value: (_vm.form.date_start),
      callback: function($$v) {
        _vm.$set(_vm.form, "date_start", $$v)
      },
      expression: "form.date_start"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "date_delivery"
    }
  }, [_c('label', [_vm._v("交房日期")]), _c('datepicker', {
    attrs: {
      "type": "date",
      "clearable": false,
      "placeholder": "交房日期",
      "min": _vm.form.date_start
    },
    model: {
      value: (_vm.form.date_delivery),
      callback: function($$v) {
        _vm.$set(_vm.form, "date_delivery", $$v)
      },
      expression: "form.date_delivery"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "duration_months"
    }
  }, [_c('label', [_vm._v("合同时长 (月)")]), _c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.form.duration_months),
      callback: function($$v) {
        _vm.$set(_vm.form, "duration_months", $$v)
      },
      expression: "form.duration_months"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "date_end"
    }
  }, [_c('label', [_vm._v("结束日期")]), _c('datepicker', {
    attrs: {
      "type": "date",
      "clearable": false,
      "placeholder": "结束日期",
      "min": _vm.form.date_start
    },
    model: {
      value: (_vm.form.date_end),
      callback: function($$v) {
        _vm.$set(_vm.form, "date_end", $$v)
      },
      expression: "form.date_end"
    }
  })], 1)], 1), _c('div', {
    staticClass: "four fields"
  }, [_c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "pay_unit_month"
    }
  }, [_c('label', [_vm._v("租金交付单位 (月)")]), _c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.form.pay_unit_month),
      callback: function($$v) {
        _vm.$set(_vm.form, "pay_unit_month", $$v)
      },
      expression: "form.pay_unit_month"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "pay_unit_month"
    }
  }, [_c('label', [_vm._v("租金 / 月")]), _c('el-input-number', {
    attrs: {
      "type": "number",
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.form.price_month),
      callback: function($$v) {
        _vm.$set(_vm.form, "price_month", $$v)
      },
      expression: "form.price_month"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "management_fee_month"
    }
  }, [_c('label', [_vm._v("管理费 / 月")]), _c('el-input-number', {
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.form.management_fee_month),
      callback: function($$v) {
        _vm.$set(_vm.form, "management_fee_month", $$v)
      },
      expression: "form.management_fee_month"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "network_fee_month"
    }
  }, [_c('label', [_vm._v("网络费 / 月")]), _c('el-input-number', {
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.form.network_fee_month),
      callback: function($$v) {
        _vm.$set(_vm.form, "network_fee_month", $$v)
      },
      expression: "form.network_fee_month"
    }
  })], 1)], 1), _c('h3', [_vm._v("预订人信息")]), _c('div', {
    staticClass: "three fields"
  }, [_c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "customer_name"
    }
  }, [_c('label', [_vm._v("姓名")]), _c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.customer_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "customer_name", $$v)
      },
      expression: "form.customer_name"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "customer_phone"
    }
  }, [_c('label', [_vm._v("手机")]), _c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.customer_phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "customer_phone", $$v)
      },
      expression: "form.customer_phone"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field",
    attrs: {
      "prop": "customer_idcard"
    }
  }, [_c('label', [_vm._v("身份证")]), _c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.customer_idcard),
      callback: function($$v) {
        _vm.$set(_vm.form, "customer_idcard", $$v)
      },
      expression: "form.customer_idcard"
    }
  })], 1)], 1), _c('h3', [_vm._v("定金")]), _c('div', {
    staticClass: "two fields"
  }, [_c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "earnest_money"
    }
  }, [_c('label', [_vm._v("定金")]), _c('el-input-number', {
    attrs: {
      "type": "number",
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.form.earnest_money),
      callback: function($$v) {
        _vm.$set(_vm.form, "earnest_money", $$v)
      },
      expression: "form.earnest_money"
    }
  })], 1), _c('el-form-item', {
    staticClass: "field",
    attrs: {
      "prop": "payment_method"
    }
  }, [_c('label', [_vm._v("支付方式")]), _c('payment-method-select', {
    model: {
      value: (_vm.form.payment_method),
      callback: function($$v) {
        _vm.$set(_vm.form, "payment_method", $$v)
      },
      expression: "form.payment_method"
    }
  })], 1)], 1), _c('h3', [_vm._v("备注")]), _c('el-form-item', {
    staticClass: "ui field",
    attrs: {
      "prop": "note"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.note),
      expression: "form.note"
    }],
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.form.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "note", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "ui field actions"
  }, [_c('div', {
    staticClass: "ui button themed icon labeled",
    on: {
      "click": _vm.finish
    }
  }, [_c('i', {
    staticClass: "icon checkmark"
  }), _vm._v("确认签署")]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("空房可预定")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ecb6d35","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/FormNewPreorder.vue
// module id = 395
// module chunks = 0